import { Component } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { DownloadSVG } from '../../../svgComponents/downloadSVG/';
import styles from './DownloadButton.module.css';
import messages from './DownloadButton.messages';

class DownloadButton extends Component {
    getDownloadClassName() {
        const { className, pending } = this.props;

        if (pending) {
            return classNames(className, styles.downloadPending);
        }

        return classNames(className, styles.download);
    }

    handleClick = () => {
        const { onClick, pending } = this.props;

        if (!pending && onClick) {
            onClick();
        }
    };

    render() {
        const { iconOnly } = this.props;

        return (
            <div
                className={this.getDownloadClassName()}
                onClick={this.handleClick}
            >
                {!iconOnly && <FormattedMessage {...messages.download} />}
                <DownloadSVG className={styles.downloadIcon} />
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default DownloadButton;
